import React from "react";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import styles from "./dropdownButton.css";

export interface Option {
  value: string;
  label: string;
}

export interface Props {
  options: Array<Option>;
  label: string;
  onAction: (value?: string) => void;
  className?: string;
}

export interface State {
  open: boolean;
}

export class DropdownButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleButtonClick() {
    if (this.props.options.length === 0) {
      this.props.onAction();
    } else {
      this.setState((prevState) => {
        return { open: !prevState.open };
      });
    }
  }

  handleOptionClick(option: Option) {
    this.setState({ open: false });
    this.props.onAction(option.value);
  }

  renderButton() {
    return (
      <AgentButton
        onClick={() => this.handleButtonClick()}
        buttonStyle={"outlined primary"}
        fullWidth
        textStyle={{ fontSize: "16px", padding: "4px 0" }}
      >
        {this.props.label}
      </AgentButton>
    );
  }

  render() {
    return (
      <div
        className={[styles["dropdown-button"]]
          .concat(this.props.className ? [this.props.className] : [])
          .join(" ")}
      >
        {this.renderButton()}
        <div
          className={[styles["dropdown-content"]]
            .concat(this.state.open ? [styles["dropdown-open"]] : [])
            .join(" ")}
        >
          {this.props.options.map((opt) => (
            <div
              key={opt.value}
              className={styles["dropdown-option"]}
              onClick={() => this.handleOptionClick(opt)}
              id={opt.value.toLowerCase() + "_dropdown_option"}
            >
              {opt.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
